import { Award } from "iconsax-react";

import IntlMessages from "../../layout/components/lang/IntlMessages";

const pages = [
  {
    header: <IntlMessages id="sidebar-pages" />,
  },
  {
    id: "superadmin",
    title: "Superadmin",
    icon: <i className="ph-bold ph-shield-star" />,
    navLink: "/pages/superadmin",
    superadminOnly: true,
  },
  {
    id: "log-auditoria-geral",
    title: "Log de Auditoria Geral",
    icon: <i className="ph-bold ph-scroll" />,
    navLink: "/pages/log-auditoria-geral",
    superadminOnly: true,
  },
  {
    id: "profile",
    title: <IntlMessages id="sidebar-pages-profile" />,
    icon: <i className="ph-fill ph-user-circle" />,
    children: [
      {
        id: "profile-personel-information",
        title: <IntlMessages id="sidebar-pages-profile-personel-information" />,
        navLink: "/pages/profile/personel-information",
      },
      {
        id: "profile-notifications",
        title: <IntlMessages id="sidebar-pages-profile-notifications" />,
        navLink: "/pages/profile/notifications",
      },
      {
        id: "profile-activity",
        title: <IntlMessages id="sidebar-pages-profile-activity-monitor" />,
        navLink: "/pages/profile/activity",
      },
      {
        id: "profile-security",
        title: <IntlMessages id="sidebar-pages-profile-security-settings" />,
        navLink: "/pages/profile/security",
      },
      {
        id: "profile-password-change",
        title: <IntlMessages id="sidebar-pages-profile-password-change" />,
        navLink: "/pages/profile/password-change",
      },
      {
        id: "profile-connect-with-social",
        title: <IntlMessages id="sidebar-pages-profile-connect-with-social" />,
        navLink: "/pages/profile/connect-with-social",
      },
    ],
  },
  {
    id: "pricing",
    title: <IntlMessages id="sidebar-pages-pricing" />,
    icon: <i className="ph-fill ph-hand-coins" />,
    navLink: "/pages/pricing",
  },
  {
    id: "faq",
    title: <IntlMessages id="sidebar-pages-faq" />,
    icon: <i className="ph-fill ph-question" />,
    navLink: "/pages/faq",
  },
];

export default pages;
